module.exports = __webpack_public_path__ + "media/images/temp/ribbon-2-644e657ff108b300154bae1484749b25.png";